import React  from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getGoalsAndAveragesStatistics } from './queries/queries';
import DataProcessor from '../../common/dataProcessors/goalsAndAveragesDataProcessor';
import GoalsAndAveragesWidget from '../../common/widgets/goalsAndAverages';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class GoalsAndAverages extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.weekly.goalsAndAverages
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'week');
  }

  get comment() {
    return super.comment || <div className="chart-title">This week's daily average per group member</div>;
  }

  render() {
    return (
      <GoalsAndAveragesWidget data={this.dataProcessor.data} title="Weekly Goals and Averages"
                              comment={this.comment}
                              chartData={this.dataProcessor.chartData} chartTitle="Group members are reaching this week"
                              loading={this.props.data.loading} />
    );
  }
}

export default compose(
  graphql(getGoalsAndAveragesStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(GoalsAndAverages);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/weekly/goalsAndAverages.js